import {http as _http} from '../http'

function _get (url) {
  return _http.get(url).then(response => response.data)
}

function _post (url, data) {
  return _http.post(url, data).then(response => response.data)
}

function _put (url, data) {
  return _http.put(url, data).then(response => response.data)
}

function _destroy (url) {
  return _http.delete(url).then(response => response.data)
}

export const get = _get
export const post = _post
export const put = _put
export const destroy = _destroy



// WEBPACK FOOTER //
// ./src/app/http.js